import styled from 'styled-components';
import { palette } from 'styled-tools';

import { CheckSimple, WarningSolid } from '@calm-web/icons';

import { StepStatus } from './types';

export const StepperContainer = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
`;

export const StepWrapper = styled.div<{ $isLast: boolean }>`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;

	${props =>
		!props.$isLast &&
		`
		&::after {
			content: '';
			position: absolute;
			top: 12px;
			left: calc(50% + 20px);
			right: calc(-50% + 20px);
			height: 2px;
			background-color: rgba(0, 0, 0, 0.26);
			z-index: 0;
		}
	`}
`;

export const StepIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 8px;
`;

const getStepLabelColor = (stepStatus: StepStatus): string => {
	switch (stepStatus) {
		case StepStatus.DISABLED:
			return 'rgba(0, 0, 0, 0.38)';
		case StepStatus.COMPLETED:
		case StepStatus.CURRENT:
			return 'rgba(0, 0, 0, 0.87)';
	}
};

const getStepLabelFontWeight = (stepStatus: StepStatus): number => {
	switch (stepStatus) {
		case StepStatus.DISABLED:
			return 500;
		case StepStatus.COMPLETED:
		case StepStatus.CURRENT:
			return 600;
	}
};

export const StepLabelText = styled.span<{ $stepStatus: StepStatus }>`
	font-weight: ${props => getStepLabelFontWeight(props.$stepStatus)};
	color: ${props => getStepLabelColor(props.$stepStatus)};
	text-align: center;
	font-size: 16px;

	@media (max-width: 900px) {
		font-size: 12px;
	}
`;

export const CompletedStepIconWrapper = styled.div`
	width: 24px;
	height: 24px;
	background-color: ${palette('blue3')};
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const VisitedStepIconWrapper = styled.div`
	width: 24px;
	height: 24px;
	background-color: ${palette('blue3')};
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${palette('white')};
	font-weight: bold;
	font-size: 12px;
`;

export const InactiveStepIconWrapper = styled.div`
	width: 24px;
	height: 24px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const ErrorStepIconWrapper = styled.div`
	width: 24px;
	height: 24px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const ClickableStepButton = styled.button.attrs({ type: 'button' })`
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: 16px;
`;
export const StyledCircleCheck = styled(CheckSimple)`
	color: ${palette('blue3')};
	fill: ${palette('blue3')};
	width: 20px;
	height: 20px;
	path {
		fill: ${palette('white')};
	}
`;

export const StyledWarningOutline = styled(WarningSolid)`
	color: ${palette('errorRed')};
	fill: ${palette('errorRed')};
	width: 24px;
	height: 24px;
	flex-shrink: 0;
`;
